export default __webpack_public_path__ + "static/ave2-bc9e7ae39770c1daa8087dd0ba351990.jpg";